var lists_default = {
  "fontElementMap": "h-f1V",
  "orderedlist": "k-IXX",
  "bulletedlist": "cDs5P",
  "listItem": "tsUtq"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
